import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';

import WithRouter from '../../utilities/WithRouter';
import { setCurrentCampus } from '../../actions';

import { useCampusFeatureFlags } from '../../context/CampusContextProvider';

import AddIcon from '../../components/icons/AddIcon';
import icon_car from '../../assets/icon_car.svg';
import icon_edit from '../../assets/icon_edit.svg';
import icon_trash from '../../assets/icon_trash.svg';
import icon_close from '../../assets/icon_close.svg';

import './ev.scss';

const EVContent = ({ currentEVData, showMobile, openEVModal, powerDecisions }) => {
  const { hasBattery } = useCampusFeatureFlags();

  function formatTime(time) {
    let newTime = time.split(' ').slice(1).join(' ');

    let hours = newTime.substring(0, newTime.indexOf(':'));
    hours = hours < 10 ? '0' + hours : hours;

    let minutes = newTime.substring(newTime.indexOf(':') + 1);

    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const ampm = hours >= 12 ? 'PM' : 'AM';

    return `${formattedHours}:${minutes} ${ampm}`;
  }

  return (
    <>
      {currentEVData && currentEVData.gridInterconnectEvChargers && (
        <>
          {currentEVData.gridInterconnectEvChargers.map((item, index) => (
            <React.Fragment key={`section-${index}`}>
              <div className="ev-header">
                <h3>
                  {item.gridInterconnectShortDescription !== ''
                    ? item.gridInterconnectShortDescription
                    : item.gridInterconnectEntityKey}
                </h3>

                <div className="add-group">
                  <button
                    onClick={() => openEVModal('edit-ev', '', '', item.gridInterconnectEntityKey)}
                  >
                    <AddIcon
                      backgroundFill="#047290"
                      strokeColor="#FFFFFF"
                      strokeWidth={3}
                      width="18px"
                    />
                    Add Group
                  </button>
                </div>
              </div>

              {item.evChargerGroups.map((group, index) => (
                <React.Fragment key={`group-${index}`}>
                  <div className="group-container">
                    <div className="group-header">
                      <h3>{group.evChargerGroupName}</h3>

                      <div className="group-edit">
                        <div
                          className="edit-button"
                          onClick={() =>
                            openEVModal(
                              'edit-ev',
                              group.evChargerGroupId,
                              '',
                              item.gridInterconnectEntityKey
                            )
                          }
                        >
                          <img
                            src={icon_edit}
                            alt="pencil and paper edit icon"
                            className="edit"
                            width="15"
                            height="15"
                          />
                        </div>
                        <div
                          className="delete-button"
                          onClick={() =>
                            openEVModal(
                              'confirm',
                              group.evChargerGroupId,
                              'delete',
                              item.gridInterconnectEntityKey
                            )
                          }
                        >
                          <img
                            src={icon_trash}
                            alt="trash can delete icon"
                            className="delete"
                            width="15"
                            height="15"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="group-contents">
                      <div className="group-devices">
                        <h4>Devices</h4>

                        <div className="group-item">
                          <table className="table--devices">
                            <colgroup span="2"></colgroup>
                            <tbody>
                              <tr>
                                <td rowSpan="2"></td>
                                <th className="capacity" colSpan="2" scope="colgroup">
                                  Capacity
                                </th>
                              </tr>
                              <tr>
                                <th className="subhead subcol" scope="col">
                                  Max
                                </th>
                                <th className="subhead subcol" scope="col">
                                  Current
                                </th>
                                <th className="subhead measured" scope="col">
                                  Measured
                                </th>
                              </tr>
                              {group.evChargers.map((charger, index) => (
                                <React.Fragment key={`charger-${index}`}>
                                  <tr>
                                    <td className="name">
                                      <img src={icon_car} alt="car icon" width="20" height="20" />
                                      <div>{charger.shortDescription}</div>
                                    </td>
                                    <td className="subcol">
                                      <div>{charger.maxCapacityPowerkW.toFixed(2)} kW</div>
                                    </td>
                                    <td className="subcol">
                                      <div>{charger.currentCapacityPowerkW.toFixed(2)} kW</div>
                                    </td>
                                    <td className="measured">
                                      <div>{charger.realPowerkW.toFixed(2)} kW</div>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}

                              <tr className="total">
                                <th className="total">Total</th>
                                <td className="subcol">{group.maxPowerCapacitykW.toFixed(2)} kW</td>
                                <td className="subcol">
                                  {group.currentPowerCapacitykW.toFixed(2)} kW
                                </td>
                                <td className="measured">{group.realPowerkW.toFixed(2)} kW</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="group-limit-override">
                        <div className="group-limits">
                          <h4>Limits</h4>
                          <div className="limits-container">
                            {Object.entries(powerDecisions).map(([key, value], index) => {
                              if (!hasBattery && key === 'Microgrid') {
                                return null;
                              }

                              return (
                                <React.Fragment key={`limit-${index}`}>
                                  <div className="limit-container">
                                    <div
                                      className={
                                        group.currentPowerDecision === key
                                          ? 'limit active'
                                          : 'limit'
                                      }
                                    >
                                      <p className="limit-name">{key}</p>
                                      <p className="limit-amount">{value}%</p>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            })}
                          </div>
                        </div>

                        <div className="override">
                          <h4>Override</h4>
                          {group.currentPowerDecision === 'Override' ? (
                            <>
                              <div className="cancel-override">
                                <p>
                                  Active: {group.currentPowerCapacityPercent}% until{' '}
                                  {formatTime(group.overrideExpires)}
                                </p>
                                <div className="cancel-button">
                                  <button
                                    className="cancel"
                                    onClick={() =>
                                      openEVModal(
                                        'confirm',
                                        group.evChargerGroupId,
                                        'cancel-override',
                                        item.gridInterconnectEntityKey
                                      )
                                    }
                                  >
                                    Cancel Override
                                  </button>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <button
                                className="override"
                                onClick={() =>
                                  openEVModal(
                                    'override',
                                    group.evChargerGroupId,
                                    '',
                                    item.gridInterconnectEntityKey
                                  )
                                }
                              >
                                Set Override
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    currentCampusId: state.currentCampusId,
    currentCampusData: state.currentCampusData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(EVContent));
